import React from 'react'
import { Row, Button, Divider } from 'antd'
import { useTranslation } from 'next-i18next'
import { CustomTitle, CustomCol } from 'src/components'

interface CreateIntegrationErrorsContentProps {
  errors: { errors: string[] }
  handleCorrectErrors: () => void
  handleReactivate: () => void
  loading: boolean
}

const CreateIntegrationErrorsContent: React.FC<CreateIntegrationErrorsContentProps> = (props) => {
  const { errors, handleCorrectErrors, handleReactivate, loading } = props
  const errorList = errors?.errors
  const { t } = useTranslation()

  const hasActivatedError = errorList?.indexOf('BUSINESS_IS_DESACTIVATED') != -1
  const reactivateIsVisible = hasActivatedError && errorList?.length === 1

  return <>
    <CustomTitle label={t('developers.IntegrationErrorTittle')} type={null} />
    <ol>
      {errorList?.map((item: string, idx: number) => (
        <CustomTitle
          key={idx}
          label={`${idx + 1} - ${t(`developers.errors.${item}`)}`}
        />
      ))}
    </ol>
    <Divider />
    {reactivateIsVisible ? (
      <Row className='mt-3'>
        <CustomCol>
          <Button
            type='default'
            htmlType='button'
            className='radius-100'
            onClick={handleCorrectErrors}
          >
            {t('developers.FixErrors')}
          </Button>
        </CustomCol>
        <CustomCol>
          <Button
            type='primary'
            htmlType='button'
            loading={loading}
            onClick={handleReactivate}
            className='radius-100 float-right'
          >
            {loading ? t('developers.Reactivating') : t('developers.Reactivate')}
          </Button>
        </CustomCol>
      </Row >
    ) : (
      <div className='centered-div mt-3'>
        <Button
          block
          type='default'
          htmlType='button'
          className='radius-100'
          onClick={handleCorrectErrors}
        >
          {t('developers.FixErrors')}
        </Button>
      </div>
    )}
  </>
}

export default CreateIntegrationErrorsContent
